<section class="vl-u-spacer--large">
    <h2 class="vl-title vl-title--h2 vl-title-spacer--xsmall" [innerHtml]="title">

    </h2>
    <h4 class="vl-title vl-title--h4" *ngIf="subTitle" [innerHtml]="subTitle">

    </h4>
</section>